import { Lightning, Registry } from '@lightningjs/sdk';
import { Base } from '../../components/BaseComponent';
import { toastsTSpec, toastsTypeConf } from './Toasts.conf';
import { Toast } from '../../components/Toast.component';

export class Toasts extends Base<toastsTSpec, toastsTypeConf> {
  static override _template() {
    return {
      w: (w: number) => w,
      h: (h: number) => h,
      Toasts: {
        type: Lightning.Component,
        x: (w: number) => w / 2,
        mountX: 0.5,
        y: 24,
        flex: { direction: 'column' },
        h: (h: number) => h,
        zIndex: 30000,
        visible: false,
      },
    };
  }

  private toasts = this.getByRef('Toasts')!;

  showToast(text: string, time = 0) {
    this.toasts.visible = true;
    // this.toasts.childList.clear();
    this.toasts.childList.a({
      type: Toast,
      message: text,
    });
    this._refocus();
    if (time > 0) {
      Registry.setTimeout(() => {
        this.hideToast(text);
      }, time);
    }
  }

  hideToast(text: string) {
    const child = this.toasts.children.find(c => (c as Toast).message === text);
    if (child) {
      this.toasts.childList.remove(child);
    }
    this.toasts.visible = this.toasts.children.length > 0;
  }
}
